import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";


import axios from "../../configApi/axiosConfig";
import { APIURL } from "../../configApi/apiConfig";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ModalFirmaElectronica } from "./ModalFirmaElectronica";
import { ModalFirmaElectronicaBancoSolidario } from "./ModalFirmaElectronicaBancoSolidario";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import useBodegaUsuario from "../../hooks/useBodegaUsuario";
import { enqueueSnackbar } from "notistack";
import { useAuth } from "../AuthContext/AuthContext";
import LocationModal from "./LocationModal";
import VerificacionTerrenaModal from "./VerificacionTerrenaModal";
import { Box, Typography } from "@mui/material";
import DomicilioModal from "./DomicilioModal";
import TrabajoModal from "./TrabajoModal";
import { RegistroCivil } from "./RegistroCivil/RegistroCivil";
import uploadFile from "../../hooks/uploadFile";
import PreDocumentos from "./Pre-Documentos";
import { useRef } from "react";
import { fetchConsultaYNotifica, fechaHoraEcuador } from "../Utils";
import { CambioBodega } from "./CambioBodega";
import ModalCorreccion from "../SolicitudGrande/Cabecera/ModalCorreccion";
import ListVerifDomicilioModal from "./ListVerifDomicilioModal";
import ListVerifLaboralModal from "./ListVerifLaboralModal"
import { DocumentoDescarga } from './DocumentoDescarga';
import { MotivoContinuidad } from './MotivoContinuidad';
import { ConfirmarAccionModal } from "./ConfirmarAccionModal";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExcelModal from './ExcelModal'
import { ObservacionCredito } from "./ObservacionCredito/ObservacionCredito";
import VerificacionFacialModal from "./VerificacionFacialModal";
import VerificacionFacialLoadingModal from "./VerificacionFacialLoadingModal";
import { VerDetallesModal } from "./VerDetallesModal";
import { AuditoriaIntegral } from "./AuditoriaIntegral";
import { useNotificationReload } from "../../notifications/hooks/useNotificationReload";
import {
} from "./ListadoSolicitud.constants";
import {
  formatDateTime,
  calcularTiempoTranscurrido,
  convertirTiempoASegundos,
  convertirSegundosATuFormato,
} from "./ListadoSolicitud.utils";
import usePermisosListado from "./usePermisosListado";
import SolicitudTableRow from "./SolicitudTableRow";
import { FiltrosListado } from "./FiltrosListado";

export function ListadoSolicitud() {
  const {
    data,
    fetchBodegaUsuario,
    listaVendedoresporBodega,
    vendedor,
    analista,
    listadoAnalista,
  } = useBodegaUsuario();

  const [recargar, setRecargar] = useState(false);
  const [loadingConsulta, setLoadingConsulta] = useState(false);

  // Caché para consultas que no cambian frecuentemente
  const [cacheTipoConsulta, setCacheTipoConsulta] = useState(null);
  const [cacheTipoCliente, setCacheTipoCliente] = useState(null);
  const [cacheAnalistas, setCacheAnalistas] = useState(null);
  const [cacheOperadores, setCacheOperadores] = useState(null);


  // Inicialización segura para evitar valores fuera de rango en el Select
  const getInitialBodega = () => {
    const saved = sessionStorage.getItem('filtroBodega');
    if (!saved || saved === 'todos') return 'todos';
    // Si el valor guardado no está en las opciones, usar 'todos'
    return 'todos';
  };
  const [selectedBodega, setSelectedBodega] = useState(getInitialBodega());
  const [selectedVendedor, setSelectedVendedor] = useState(sessionStorage.getItem('filtroVendedor') || "todos");
  const [analistaSelected, setAnalistaSelected] = useState(sessionStorage.getItem('filtroAnalista') || "todos");
  const [operadorSelected, setOperadorSelected] = useState(sessionStorage.getItem('filtroOperador') || "todos");
  const [tipoFirmaElectronica, setTipoFirmaElectronica] = useState(sessionStorage.getItem('filtroTipoFirmaElectronica') || "todos");
  const [redSocial, setRedSocial] = useState(sessionStorage.getItem('filtroRedSocial') || "todos");
  const [tipoClienteFiltro, setTipoClienteFiltro] = useState(sessionStorage.getItem('filtroTipoCliente') || "todos");
  const [dataBodega, setDataBodega] = useState([]);
  const [estado, setEstado] = useState(sessionStorage.getItem('filtroEstado') || "todos");
  const [datos, setDatos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [view, setView] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalPages, setTotalPages] = useState(1); // Total de páginas
  const [total, setTotal] = useState(0); // Total de registros
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openVerificacionModal, setOpenVerificacionModal] = useState(false);
  const [openModalPendiente, setOpenModalPendiente] = useState(false);
  const today = new Date().toISOString().split("T")[0]; // Obtener la fecha de hoy en formato YYYY-MM-DD
  const [tiposCliente, setTipo] = useState([]); // opciones { value: idTipoCliente, label: Nombre }
  const [tipoClienteMap, setTipoClienteMap] = useState({});
  const [tipoVerificacionSeleccionada, setTipoVerificacionSeleccionada] = useState(null);
  const [tipoVerificacionSeleccionada2, setTipoVerificacionSeleccionada2] = useState(null);
  const [tipoConsulta, setTipoConsulta] = useState([]);
  const date15DaysAgo = new Date();
  date15DaysAgo.setDate(date15DaysAgo.getDate() - 2);
  const date15DaysAgoStr = date15DaysAgo.toISOString().split("T")[0];
  const [fechaInicio, setFechaInicio] = useState(sessionStorage.getItem('filtroIniFecha') || date15DaysAgoStr);
  const [fechaFin, setFechaFin] = useState(sessionStorage.getItem('filtroFinFecha') || today);
  const [isDomicilioModalOpen, setDomicilioModalOpen] = useState(false);
  const handleCloseDomicilioModal = () => setDomicilioModalOpen(false);
  const [openRegistroCivil, setOpenRegistroCivil] = useState(false);
  const [registroCivilCaido, setRegistroCivilCaido] = useState(false);
  const [openAuditoriaIntegral, setOpenAuditoriaIntegral] = useState(false);
  const [auditoriaRow, setAuditoriaRow] = useState(null);
  const [isTrabajoModalOpen, setTrabajoModalOpen] = useState(false);
  const handleCloseTrabajoModal = () => setTrabajoModalOpen(false);
  const [domicilioData, setDomicilioData] = useState([]);
  const [trabajoData, setTrabajoData] = useState([]);
  const [idsTerrenas, setIdsTerrenas] = useState([]);
  const navigate = useNavigate();
  const { userData, idMenu } = useAuth();
  useNotificationReload(() => setRecargar(prev => !prev));
  const editarCodDac = userData?.idGrupo === 1 || userData?.idGrupo === 16 || userData?.idGrupo === 18;
  const editarCodDac2 = selectedRow?.Estado === 1;
  const [cedula, setCedula] = useState(sessionStorage.getItem('filtroCedula') || "");
  const [dactilar, setDactilar] = useState("");
  const [fileToUpload, setFileToUpload] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [, setUrlCloudstorage] = useState(null);
  const [resultadoVerificacion, setResultadoVerificacion] = useState([]);
  const [loadingVerificacion, setLoadingVerificacion] = useState(false);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const [, setImagenCapturada] = useState(null);
  const [fechaTiempos, setfechaTiempos] = useState([]);
  const inputFileRef = useRef(null);
  const [showModalRechazo, setShowModalRechazo] = useState(false);
  const [showModalReproceso, setShowModalReproceso] = useState(false);
  const [listVerifDomiciModal, setListVerifDomiModal] = useState(false);
  const handleCloseVerifDomModal = () => setListVerifDomiModal(false);
  const [listVerifLaborModal, setListVerifLaborModal] = useState(false);
  const handleCloseVerifLabModal = () => setListVerifLaborModal(false);
  const [isOpenPDf, setIsOpenPdf] = useState(false);
  const [isOpenMotivo, setIsOpenMotivo] = useState(false);
  const [dataInforme, setDataInforme] = useState(null);
  const [openModalCodDag, setOpenModalCodDag] = useState(false);
  const [openConfirmModalCodDac, setOpenConfirmModalCodDac] = useState(false);
  const [codDact, setCodDact] = useState("");
  const [emailSolicitud, setEmailSolicitud] = useState("");
  const [openModalEmail, setOpenModalEmail] = useState(false);
  const [openConfirmModalEmail, setOpenConfirmModalEmail] = useState(false);
  const [openModalExcel, setOpenModalExcel] = useState(false);
  const [openVerificacionModal2, setOpenVerificacionModal2] = useState(false);
  const [ExistPrefactura, setExistPrefactura] = useState(false);
  const [isPrefacturaAprobadaBS, setIsPrefacturaAprobadaBS] = useState(false);
  const [showModalCorrecion, setShowModalCorrecion] = useState(false);
  const [TipoVerificacion, setTipoVerificacion] = useState("");
  const [open, setOpen] = useState(false);
  const [observacionModalAbierto, setObservacionModalAbierto] = useState(false);
  const [motivoContinuidad, setMotivoContinuidad] = useState(false);
  const [tieneRespaldosPendientes, setTieneRespaldosPendientes] = useState(false);
  const [estadoRespaldosPendientes, setEstadoRespaldosPendientes] = useState("Todos");
  const handleOpenEditModal = () => {
    setCodDact(selectedRow.CodigoDactilar);
    setOpenModalCodDag(true);
  };

  const handleUpdateClick = () => {
    if (codDact === null || codDact.length !== 10) {
      enqueueSnackbar("El código dactilar debe tener mínimo 10 dígitos.", { variant: "error" });
      return;
    }
    setOpenConfirmModalCodDac(true);
  };

  const handleConfirmUpdate = () => {
    fetchCodDact(selectedRow)

    // Cerrar modales
    setOpenConfirmModalCodDac(false);
    setOpenModalCodDag(false);
    setView(false);
  };

  const fetchCodDact = async (selectedRow) => {
    try {
      const url = APIURL.patch_codDactil(selectedRow.id);
      const response = await axios.patch(url, {
        CodDactilar: codDact,
      }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      enqueueSnackbar("Código dactilar actualizado correctamente.", { variant: "success" })
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el código dactilar", error);
      enqueueSnackbar("Error al actualizar el código dactilar.", { variant: "error" });
      return null;
    }
  };

  const handleOpenEditEmailModal = () => {
    setEmailSolicitud(selectedRow?.email ?? "");
    setOpenModalEmail(true);
  };

  const handleUpdateEmailClick = () => {
    const emailLimpio = emailSolicitud.trim();
    const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailLimpio);
    if (!emailValido) {
      enqueueSnackbar("Ingresa un correo electrónico válido.", { variant: "error" });
      return;
    }
    setEmailSolicitud(emailLimpio);
    setOpenConfirmModalEmail(true);
  };

  const handleConfirmUpdateEmail = async () => {
    try {
      const response = await axios.patch(
        APIURL.patch_emailSolicitudGrande(selectedRow.id),
        { Email: emailSolicitud },
        { headers: { "Content-Type": "application/json" } },
      );
      const emailActualizado = response.data?.Email ?? emailSolicitud;
      setSelectedRow((prev) => ({ ...prev, email: emailActualizado }));
      enqueueSnackbar("Correo actualizado correctamente.", { variant: "success" });
      setOpenConfirmModalEmail(false);
      setOpenModalEmail(false);
    } catch (error) {
      const mensaje = error.response?.data?.message || "Error al actualizar el correo.";
      enqueueSnackbar(mensaje, { variant: "error" });
    }
  };

  const fetchEstadoRegcivil = async () => {
    try {
      const url = APIURL.patch_EstadoRegcivil(selectedRow.id);
      const response = await axios.patch(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      enqueueSnackbar("Estado actualizado correctamente.", { variant: "success" })
      handleCloseDialog()
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el Estado", error);
      enqueueSnackbar("Error al actualizar el Estado", { variant: "error" });
      return null;
    }
  }

  const fetchCuota = async (id) => {
    try {
      const url = APIURL.getSolicitudGrandeporId(id);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al obtener solicitud grande", error);
    }
  }

  // Estado para modal de error visual
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorModalData, setErrorModalData] = useState({ tipo: '', mensaje: '', detalle: '' });

  // Estados para modal de verificación facial
  const [verificacionModalOpen, setVerificacionModalOpen] = useState(false);
  const [verificacionModalTipo, setVerificacionModalTipo] = useState('');
  const [verificacionModalData, setVerificacionModalData] = useState({});

  const fetchImagenRegistroCivil = async (cedula, dactilar) => {
    try {
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };

      // Validar que userData esté disponible
      const usuario = userData?.Nombre || 'Sistema';

      // Usar directamente el nuevo endpoint que maneja todo automáticamente
      const url = APIURL.post_RegistriCivil();
      const response = await axios.post(url,
        {
          cedula,
          dactilar,
          usuario
        },
        config
      );

      // Verificar si fue exitoso
      if (response.data.success && response.data.data) {
        return { success: true, foto: response.data.data.FOTO };
      } else {
        // El RC respondió pero no encontró al ciudadano
        const mensaje = response.data.message || "No se encontró el ciudadano en el Registro Civil";
        setErrorModalData({
          tipo: 'ciudadano_no_encontrado',
          mensaje: 'Ciudadano no encontrado',
          detalle: `Los datos ingresados no coinciden con el Registro Civil:\n\n• Cédula: ${cedula}\n• Código Dactilar: ${dactilar}\n\nPor favor verifique que los datos sean correctos.`
        });
        setErrorModalOpen(true);
        return { success: false, error: mensaje };
      }
    } catch (error) {
      console.error('Error en fetchImagenRegistroCivil:', error);

      // Determinar el tipo de error
      if (error.response?.status === 404) {
        setErrorModalData({
          tipo: 'datos_incorrectos',
          mensaje: 'Datos incorrectos',
          detalle: `La cédula o código dactilar ingresado no existe en el sistema:\n\n• Cédula: ${cedula}\n• Código Dactilar: ${dactilar}\n\nVerifique los datos e intente nuevamente.`
        });
      } else if (error.response?.status === 500) {
        setErrorModalData({
          tipo: 'error_servidor',
          mensaje: 'Error del servidor',
          detalle: 'El servidor del Registro Civil no está disponible temporalmente. Por favor intente más tarde.'
        });
        setErrorModalOpen(true);
        return { success: false, serviceCaido: true, error: error.message };
      } else {
        setErrorModalData({
          tipo: 'error_conexion',
          mensaje: 'Error de conexión',
          detalle: 'No se pudo conectar con el Registro Civil. Verifique su conexión a internet e intente nuevamente.'
        });
        setErrorModalOpen(true);
        return { success: false, serviceCaido: true, error: error.message };
      }
    }
  };
  const handleAbrirVerificacionManual = async () => {
    const cedula = selectedRow?.cedula;
    const dactilar = selectedRow?.CodigoDactilar;
    const imagenSubida = selectedRow?.imagen;

    if (!cedula || !dactilar || !imagenSubida) {
      setErrorModalData({
        tipo: 'datos_incompletos',
        mensaje: 'Datos incompletos',
        detalle: 'No se pueden verificar las fotos porque faltan datos en la solicitud:\n\n' +
          `• Cédula: ${cedula || 'NO DISPONIBLE'}\n` +
          `• Código Dactilar: ${dactilar || 'NO DISPONIBLE'}\n` +
          `• Imagen: ${imagenSubida ? 'Disponible' : 'NO DISPONIBLE'}\n\n` +
          'Por favor complete los datos faltantes antes de continuar.'
      });
      setErrorModalOpen(true);
      return;
    }

    try {
      setCedula(cedula);
      setDactilar(dactilar);

      const result = await fetchImagenRegistroCivil(cedula, dactilar);

      if (result.success && result.foto && result.foto.trim() !== "") {
        setRegistroCivilCaido(false);
        setOpenRegistroCivil(true);
      } else if (result.serviceCaido) {
        // El RC no respondió — si el usuario tiene permiso, abrir con modo "caído"
        setErrorModalOpen(false);
        setRegistroCivilCaido(true);
        setOpenRegistroCivil(true);
      }
      // else: ciudadano no encontrado — el modal de error ya fue mostrado
    } catch (error) {
      console.error('Error en handleAbrirVerificacionManual:', error);
      setErrorModalData({
        tipo: 'error_inesperado',
        mensaje: 'Error inesperado',
        detalle: 'Ocurrió un error inesperado al cargar la verificación facial. Por favor intente nuevamente.'
      });
      setErrorModalOpen(true);
    }
  };

  const handleVerificarIdentidad = async (imagenSubida, fotoRegistroCivil) => {
    try {
      setLoadingVerificacion(true);

      if (!imagenSubida || !fotoRegistroCivil) {
        setErrorModalData({
          tipo: 'datos_incompletos',
          mensaje: 'Imágenes faltantes',
          detalle: 'No se puede realizar la verificación facial porque faltan las imágenes necesarias:\n\n' +
            `• Imagen subida: ${imagenSubida ? 'Disponible ✓' : 'NO DISPONIBLE ✗'}\n` +
            `• Foto Registro Civil: ${fotoRegistroCivil ? 'Disponible ✓' : 'NO DISPONIBLE ✗'}\n\n` +
            'Asegúrese de que ambas imágenes estén cargadas correctamente antes de continuar.'
        });
        setErrorModalOpen(true);
        setLoadingVerificacion(false);
        return;
      }

      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        timeout: 0, // sin límite — espera hasta que el servicio de IA responda
      };

      // El backend compara la foto de la solicitud con la del Registro Civil,
      // registra el intento (Cre_VerificacionIdentidad) y, si coincide, pasa la
      // solicitud a Estado 2 con su trazabilidad.
      const response = await axios.post(
        APIURL.postVerificarIdentidad(),
        { idSolicitud: selectedRow?.id },
        config
      );

      const verified = response.data?.verified === true;
      const distance = response.data?.distance || 0;
      const threshold = response.data?.threshold || 0.3;
      const similarityPercent = response.data?.similarity ?? 0;

      // ✅ Guarda los datos de verificación
      setResultadoVerificacion(response.data);

      if (verified) {
        if (response.data?.estadoAplicado === 2) {
          enqueueSnackbar("Solicitud actualizada correctamente.", { variant: "success" });
        }

        // Abrir modal de verificación exitosa con nuevo componente
        setVerificacionModalTipo('aprobado');
        setVerificacionModalData({
          distance,
          threshold,
          similarity: similarityPercent
        });
        setVerificacionModalOpen(true);

        setOpenRegistroCivil(false);
        setView(false);
      } else {
        // Abrir modal de verificación rechazada con nuevo componente
        setVerificacionModalTipo('rechazado');
        setVerificacionModalData({
          distance,
          threshold,
          similarity: similarityPercent
        });
        setVerificacionModalOpen(true);
        setOpenRegistroCivil(false); // Cerrar modal de RegistroCivil cuando no coincide
      }
    } catch (error) {
      console.error("Error en verificación facial:", error);
      setErrorModalData({
        tipo: 'error_verificacion',
        mensaje: 'Error en verificación',
        detalle: 'Ocurrió un error al intentar verificar las imágenes. Por favor intente nuevamente más tarde.'
      });
      setErrorModalOpen(true);
    } finally {
      setLoadingVerificacion(false);
    }
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split('.').pop().toLowerCase();
    if (extension !== "jpeg" && extension !== "jpg" && extension !== "png") {
      enqueueSnackbar("Solo archivos con extensión .jpeg son permitidos", { variant: "error" });
      e.target.value = null; // reset input
      setFileToUpload(null);
      setPreviewUrl(null);
      return;
    }

    setFileToUpload(file);
    const localUrl = URL.createObjectURL(file);
    setPreviewUrl(localUrl);
  };

  const fetchInsertarimagen = async (tipo, data, estado, imagen) => {


    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: imagen

      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error.response?.data || error.message);

    }
  };

  const handleUploadClick = async () => {
    if (!fileToUpload) {
      alert("Primero selecciona una imagen");
      return;
    }

    try {
      const fileUploadResponse = await uploadFile(
        fileToUpload,
        selectedRow.almacen,
        selectedRow.cedula,
        selectedRow.NumeroSolicitud,
        "Foto"
      );

      if (fileUploadResponse) {
        const updatedUrl = fileUploadResponse.url;

        // 1. Actualizar local
        setSelectedRow((prevRow) => ({
          ...prevRow,
          imagen: updatedUrl,
        }));

        // 2. Actualizar en la tabla
        setDatos((prevDatos) =>
          prevDatos.map((item) =>
            item.id === selectedRow.id ? { ...item, imagen: updatedUrl } : item
          )
        );

        // 3. Actualizar en backend
        const updatedData = { Foto: updatedUrl };
        await fetchActualizaSolicitud(selectedRow.id, updatedData);
        fetchInsertarimagen(1, selectedRow.id, 14, updatedUrl)

        setUrlCloudstorage();
        setFileToUpload(null);

        enqueueSnackbar("Foto subida correctamente", {
          variant: "success",
        });


      }
    } catch (error) {
      alert(error.message);
    }
  };


  const fetchActualizaSolicitud = async (idSolicitud, data) => {
    try {
      const url = APIURL.putUpdatesolicitud(idSolicitud); // URL para actualizar la solicitud
      const response = await axios.put(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response.data; // Retornar datos actualizados si es necesario
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error.message);
      throw error; // Re-lanzar error para manejarlo más tarde
    }
  };

  const bodegas = useMemo(() => data || [], [data]); // Safely access the bodegas data
  const vendedores = useMemo(() => vendedor || [], [vendedor]); // Safely access the vendedores data
  const analistas = useMemo(() => analista || [], [analista]); // Safely access the analistas data

  const [clienteEstados, setClienteEstados] = useState([]);

  const verificacionSolicitud = (data) => {
    return data.idEstadoVerificacionSolicitud !== 12;
  };

  ///// METODO QUE VALIDE SI 3 TIPOS DE DOCUMENTO UNICAMENTE YA FUERON APROBADOS 
  const [, setDocAprobados] = useState({}); //

  // función para verificar documentos
  const laboralYDomicilioAprobados = async (id) => {
    try {
      const response = await axios.get(APIURL.getVerificacionTresDocumentos(id));
      return response.data.allThreeDocsApproved; // true o false
    } catch (error) {
      console.error("Error fetching data:", error);
      return false; // si hay error, consideramos como no aprobado
    }
  };

  // ahora en el useEffect
  useEffect(() => {
    const verificarTodosDocumentos = async () => {
      const resultados = {}; // objeto para guardar resultados por id

      for (const solicitud of datos) {
        const aprobado = await laboralYDomicilioAprobados(solicitud.id);
        resultados[solicitud.id] = aprobado;
      }

      setDocAprobados(resultados); // guarda todo junto
    };

    if (datos.length > 0) {
      verificarTodosDocumentos();
    }
  }, [datos]);

  const estaDeshabilitado = (data) => {
    return data.resultado === 0;
  };

  const [solicitud, setSolicitud] = useState(sessionStorage.getItem('filtroSolicitud') || "Todos");
  const [documental, setDocumental] = useState(sessionStorage.getItem('filtroDocumental') || "Todos");
  const [telefonica, setTelefonica] = useState(sessionStorage.getItem('filtroTelefonica') || "Todos");
  const [domicilio, setDomicilio] = useState(sessionStorage.getItem('filtroDomicilio') || "Todos");
  const [laboral, setLaboral] = useState(sessionStorage.getItem('filtroLaboral') || "Todos");
  const [nombre, setNombre] = useState(sessionStorage.getItem('filtroNombre') || "");
  const [numeroSolicitud, setNumeroSolicitud] = useState(sessionStorage.getItem('filtroNumSolicitud') || "");

  const [openDialog2, setOpenDialog2] = useState(false);
  const [currentAction, setCurrentAction] = useState(null); // Estado para saber qué acción se va a realizar
  const [currentData, setCurrentData] = useState([]);
  const [laboralChecked, setLaboralChecked] = useState(false);
  const [domicilioChecked, setDomicilioChecked] = useState(false);
  const [entrada, setEntrada] = useState("");



  const [justificacion, setJustificacion] = useState("");

  const handleConfirm = async () => {
    if (currentAction === "estado") {
      handleApproveEstado(currentData, justificacion);
      if (laboralChecked) await patchLaboral(currentData.id);
      if (true) await patchDomicilio(currentData.id);
      if (entrada.trim() !== "") await patchEntrada(currentData.id, entrada);
    } else if (currentAction === "resultado") {
      handleApproveResultado(currentData);
      if (laboralChecked) await patchLaboral(currentData.id);
      if (domicilioChecked) await patchDomicilio(currentData.id);
      if (entrada.trim() !== "") await patchEntrada(currentData.id, entrada);
    }

    setOpenDialog2(false);
    setLaboralChecked(false);
    setDomicilioChecked(false);
    setEntrada("");
    setJustificacion("");
    setRecargar(true)
  };

  const patchEntrada = async (idSolicitud, valor) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        {
          Entrada: parseFloat(valor),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        enqueueSnackbar("Entrada registrada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la entrada:", error);
      enqueueSnackbar("Error al actualizar la entrada.", {
        variant: "error",
      });
    }
  };

  const patchDomicilio = async (idSolicitud) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        {
          TerrenoDomicilio: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        enqueueSnackbar("Solicitud actualizada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }
  };

  const patchLaboral = async (idSolicitud) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        {
          TerrenoLaboral: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        enqueueSnackbar("Solicitud actualizada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }
  };

  const fetchInsertarDatos = async (tipo, data, estado) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,


      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };

  const fetchInsertarDatosAprobarEstado = async (tipo, data, estado, observacion) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: observacion


      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };




  const fetchInsertarDatosRechazo = async (tipo, data, estado, observacion) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: observacion


      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };
  const fetchInsertarDatos2 = async (tipo, data, estado) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      const analistaNombre = analistas.find((a) => a.idUsuario === data.idAnalista)?.Nombre || "No disponible";
      await axios.post(url, {
        idCre_SolicitudWeb: data.id,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: analistaNombre

      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };

  const fetchInsertarDatos3 = async (tipo, data, estado) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      const operadorNombre = operadores.find((a) => a.idUsuario === data.Operador)?.Nombre || "Vacio";
      await axios.post(url, {
        idCre_SolicitudWeb: data.id,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: operadorNombre

      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };



  const handleApproveEstado = async (data, justificacion) => {
    try {
      await patchSolicitudEstadoyResultado(data.id, { Estado: 1, Resultado: 1 });
      //await patchSolicitudEstadoyResultado(data.id, { Resultado: 1 });
      await fetchInsertarDatosAprobarEstado(6, data.id, 1, justificacion); // ✅ Usar la nueva función con observación
      setRecargar(true);
      setShowModalRechazo(false)
    } catch (error) {
      console.error("Error al pre-aprobar estado:", error);
    }


  };

  const handleApproveResultado = (data) => {
    patchSolicitudEstadoyResultado(data.id, { Resultado: 1 });
    patchSolicitudEstadoyResultado(data.id, { Estado: 1 });
    fetchInsertarDatos(7, data.id, 1);
    setRecargar(true);
  };

  const patchSolicitudEstadoyResultado = async (
    idSolicitud,
    camposActualizar
  ) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        camposActualizar, // Esto puede ser { Estado: 2 } o { Resultado: 1 }
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        enqueueSnackbar("Solicitud actualizada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }
  };

  // Abre el Popover cuando el InfoIcon es clickeado
  const handlePopoverOpen = (event, tipo, data) => {
    fetchtiemposolicitudesweb(data.id, tipo);
    setPopoverData({
      open: true,
      anchorEl: event.currentTarget,
      selectedRowId: data.id, // Guardar la ID de la fila seleccionada
    });
  };

  const [popoverData, setPopoverData] = React.useState({
    open: false,
    anchorEl: null,
    clienteEstados: [],
    selectedRowId: null, // ID para identificar qué fila tiene el popover abierto
  });

  const handlePopoverClose = () => {
    setPopoverData({ open: false, anchorEl: null, selectedRowId: null });
  };

  const [userSolicitudData, setUserSolicitudData] = useState([]);
  const [userSolicitudData2, setUserSolicitudData2] = useState([]);

  // Estado para mostrar el modal de firma electrónica
  const [modalFirmaOpen, setModalFirmaOpen] = useState(false);

  // Cargar catálogos estáticos que no dependen del usuario
  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchTipoConsulta(),
          fetchTipoCliente(),
          fecthAnalista(),
          fetchOperador(),
          fetchTipoFirmaElectronica()
        ]);
      } catch (error) {
        console.error("Error al cargar los datos iniciales:", error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cargar bodegas (depende del usuario)
  useEffect(() => {
    if (userData?.idUsuario) {
      fetchBodega();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.idUsuario]);

  // Cargar permisos en un efecto separado para que re-ejecute cuando userData
  // llegue de forma asíncrona (ej. tras F5, donde userData es null en el primer
  // render y el contexto lo resuelve unos milisegundos después).
  useEffect(() => {
    if (userData?.idUsuario && idMenu) {
      permissionscomponents(idMenu, userData.idUsuario);
    }
  }, [userData?.idUsuario, idMenu]); // eslint-disable-line react-hooks/exhaustive-deps

  const [permisos, setPermisos] = useState([]);
  const {
    permisoAprobarEstado,
    tienePermisoEditarAnalista,
    permisoEditarOperador,
    permitirEquifax,
    imprimirInforme,
    crearYupana,
    permisoReasignarVerificador,
    permisoEditarVerificacionTerreno,
    permisoReasignarDomicilio,
    permisoAgregarObservacionCredito,
    permisoReasignarLaboral,
    permisoCambiarBodega,
    puedeCrearSolicitud,
    puedeCrearSolicitudNueva,
    estadoDeshabilitadoporPermisos,
    estadoDeshabilitadotelefonica,
    estadoDeshabilitadoDocumental,
    aporbarsinregistrocivil,
    puedeDescargarDocumentosBS,
    puedeReenviarFirmaBS,
  } = usePermisosListado(permisos);

  const permissionscomponents = async (idMenu, idUsuario) => {
    try {
      const url = APIURL.getacces(idMenu, idUsuario);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        setPermisos(data);
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching permissions components:", error);
    }
  };

  const fetchtiemposolicitudesweb = async (idCre_SolicitudWeb, estado) => {
    try {
      const url = APIURL.get_tiemposolicitudesweb(idCre_SolicitudWeb, estado);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        setClienteEstados(data);
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching tiemposolicitudesweb data:", error);
    }
  };

  const fetchTiempSolicweb = async (tipo, idCre_SolicitudWeb, estado) => {
    try {
      const url = APIURL.get_TiempSolicWeb(tipo, idCre_SolicitudWeb, estado);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching tiemposolicitudesweb data:", error);
      return null;
    }
  };

  const validaPrefactura = async (Cedula, Bodega) => {
    try {
      const url = APIURL.validaPrefactura(Cedula, Bodega);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {

        setExistPrefactura(true);
      } else {

        setExistPrefactura(false);
      }
    } catch (error) {
      console.error("Error fetching tiemposolicitudesweb data:", error);
      return null;
    }
  };

  const validaPrefacturaAprobadaBS = async (cedula, bodega) => {
    try {
      const response = await axios.get(APIURL.validaPrefacturaAprobadaBS(cedula, bodega));
      setIsPrefacturaAprobadaBS(response.data.success === true);
    } catch (error) {
      console.error("Error al validar prefactura aprobada BS:", error);
      setIsPrefacturaAprobadaBS(false);
    }
  };

  const sumarTodosLosTiempos = () => {
    // Obtener todos los elementos con la clase 'tiempo-transcurrido'
    const elementosTiempo = Array.from(document.querySelectorAll('.tiempo-transcurrido'));

    let totalSegundos = 0;
    let tiemposValidos = 0;

    elementosTiempo.forEach(elemento => {
      const tiempoTexto = elemento.textContent.trim();
      if (tiempoTexto && tiempoTexto !== "N/A") {
        totalSegundos += convertirTiempoASegundos(tiempoTexto);
        tiemposValidos++;
      }
    });

    if (tiemposValidos === 0) return "N/A";

    return convertirSegundosATuFormato(totalSegundos);
  };

  const [, setTiempoTotal] = useState("N/A");

  useEffect(() => {
    // Usar ResizeObserver para actualizar el tiempo total cuando cambia el tamaño
    const observer = new ResizeObserver(() => {
      const timer = setTimeout(() => {
        setTiempoTotal(sumarTodosLosTiempos());
      }, 100);
      return () => clearTimeout(timer);
    });

    // Observar el contenedor principal
    const dialogElement = document.querySelector('.MuiDialog-paper');
    if (dialogElement) {
      observer.observe(dialogElement);
    }

    // También actualizar cuando cambian las fechas
    setTiempoTotal(sumarTodosLosTiempos());

    return () => {
      if (dialogElement) {
        observer.unobserve(dialogElement);
      }
      observer.disconnect();
    };
  }, [fechaTiempos]);

  const [idsTerrenasMap, setIdsTerrenasMap] = useState({});
  const [openPreDocumentos, setOpenPreDocumentos] = useState(false);
  const [preDocumentosData, setPreDocumentosData] = useState(null);
  const handleOpenModalVerificacion = async (data, tipo) => {
    try {
      let idtipo = 0;
      if (tipo === "domicilio") idtipo = 1;
      else if (tipo === "trabajo") idtipo = 2;

      const url = APIURL.getIdsTerrenas(data.id, idtipo);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status !== 200) {
        throw new Error("Error al obtener los IDs terrenas");
      }

      const idsTerrenas = response.data;

      setIdsTerrenasMap((prev) => ({
        ...prev,
        [data.id]: idsTerrenas,
      }));

      setIdsTerrenas(idsTerrenas);
      setUserSolicitudData2(data);
      setTipoVerificacionSeleccionada2(tipo)

      if (!idsTerrenas || idsTerrenas.length === 0) {
        // No hay datos, abrir PreDocumentos (nuevo componente)
        setPreDocumentosData({ data, tipo });
        if (userData?.idGrupo !== 22 && userData?.idGrupo !== 23 && userData?.idGrupo !== 19) {
          setOpenPreDocumentos(true);
        }
        return;
      }

      if (tipo === "domicilio") {
        if (idsTerrenas.idTerrenaGestionDomicilio > 0) {
          setDomicilioData({ ...idsTerrenas, idSolicitud: data.id, cliente: data });
          //setDomicilioModalOpen(true);
          setListVerifDomiModal(true);
        } else if (idsTerrenas.idTerrenaGestionDomicilio === 0) {
          await fetchtiemposolicitudesweb(data.id, 4);
          setOpenModalPendiente(true);
        }
        return;
      }

      if (tipo === "trabajo") {
        if (idsTerrenas.idTerrenaGestionTrabajo > 0) {
          setTrabajoData({ ...idsTerrenas, idSolicitud: data.id, cliente: data });
          //setTrabajoModalOpen(true);
          setListVerifLaborModal(true)
        } else if (idsTerrenas.idTerrenaGestionTrabajo === 0) {
          await fetchtiemposolicitudesweb(data.id, 5);
          setOpenModalPendiente(true);
        }
        return;
      }

    } catch (error) {
      console.error("Error fetching data for verificación terrena:", error);
    }
  };

  const [, setSelectDeshabilitado] = useState(false);

  useEffect(() => {
    if (userData?.Nombre && analistas?.length > 0) {
      const analistaCoincidente = analistas.find((a) => {
        const nombreAnalista = a.Nombre?.toLowerCase().trim();
        const nombreUser = userData.Nombre?.toLowerCase().trim();
        return nombreAnalista === nombreUser;
      });

      if (analistaCoincidente) {
        setAnalistaSelected(analistaCoincidente.idUsuario);
        setSelectDeshabilitado(true);
      } else {
        setSelectDeshabilitado(false);
      }
    }
  }, [userData?.Nombre, analistas]);

  // Obtener bodegas
  const fetchBodega = async () => {
    try {
      const userId = userData?.idUsuario;
      const idTipoFactura = 43;
      const fecha = new Date().toISOString();
      const recibeConsignacion = true;

      await fetchBodegaUsuario(
        userId,
        idTipoFactura,
        fecha,
        recibeConsignacion
      );
    } catch (err) {
      console.error("Error al obtener datos de la bodega:", err);
    }
  };

  // si cambia la bodega llamae a fecthUsuariobodega

  useEffect(() => {
    if (!userData?.FechaIngreso) return
    const fechaIngreso = new Date(userData.FechaIngreso).toISOString().split('T')[0];
    const idGrupo = userData?.idGrupo

    if (selectedBodega !== "todos") {
      if (Number(idGrupo) === 23 && fechaIngreso >= fechaInicio) {
        fecthaUsuarioBodega(fechaIngreso, selectedBodega, 0);
        setFechaInicio(fechaIngreso)
      } else {
        fecthaUsuarioBodega(fechaInicio, selectedBodega, 0);
      }
    } else {
      fetchSolicitudes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBodega, fechaInicio, userData]);


  const fecthaUsuarioBodega = async (fecha, bodega, nivel) => {
    try {
      await listaVendedoresporBodega(fecha, bodega, nivel);
    } catch (err) {
      console.error("Error al obtener datos de la bodega:", err);
    }
  };

  const fecthAnalista = async () => {
    try {
      await listadoAnalista();
    } catch (err) {
      console.error("Error al obtener datos de la bodega:", err);
    }
  };

  /*  const tipoVerificacionMap = {
    1: "Dirección incorrecta",
    2: "Aprobado",
    3: "Malas referencias",
    4: "No vive ahí",
    5: "Datos falsos",
    6: "Zona Vetada",
    7: "No sustenta ingresos",
  };*/

  const puedeAprobar = (data) => {
    if (!data) return false;

    const condicionesBase =
      data.idEstadoVerificacionDocumental === 4 &&
      data.idEstadoVerificacionSolicitud === 12 &&
      data.idEstadoVerificacionTelefonica === 3;

    /*const verificacionDomicilioOk =
      !data.Domicilio || data.idEstadoVerificacionDomicilio === 2;

    const verificacionLaboralOk =
      !data.Laboral || data.idEstadoVerificacionTerrena === 2;
*/
    return condicionesBase
  };

  const bodegasIds = bodegas.map((bodega) => bodega.b_Bodega); // Obtener los IDs de las bodegas
  // Obtener tipo de consulta con caché
  const fetchTipoConsulta = async () => {
    // Verificar si ya existe en caché
    if (cacheTipoConsulta) {
      setTipoConsulta(cacheTipoConsulta);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(APIURL.getTipoConsulta(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const data = response.data.map((item) => ({
          id: item.idCompraEncuesta,
          descripcion: item.Descripcion,
        }));
        setTipoConsulta(data);
        setCacheTipoConsulta(data); // Guardar en caché
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching tipo de consulta:", error);
    }
  };

  const fetchTipoCliente = async () => {
    // Verificar si ya existe en caché
    if (cacheTipoCliente) {
      const tipoMap = cacheTipoCliente.reduce((acc, item) => {
        acc[item.idTipoCliente] = item.Nombre;
        return acc;
      }, {});
      setTipoClienteMap(tipoMap);
      setTipo(
        cacheTipoCliente.map((item) => ({
          value: item.idTipoCliente,
          label: item.Nombre,
        }))
      );
      return;
    }

    try {
      const response = await axios.get(APIURL.getTipoCliente());
      if (response.status === 200) {
        // Guardar en caché
        setCacheTipoCliente(response.data);

        // Crear un mapeo de idTipoCliente a Nombre
        const tipoMap = response.data.reduce((acc, item) => {
          acc[item.idTipoCliente] = item.Nombre;
          return acc;
        }, {});
        setTipoClienteMap(tipoMap);
        setTipo(
          response.data.map((item) => ({
            value: item.idTipoCliente,
            label: item.Nombre,
          }))
        );
      } else {
        throw new Error("Error en la respuesta del servidor");
      }
    } catch (error) {
      console.error("Error al obtener el tipo de cliente:", error);
      enqueueSnackbar("No se pudo cargar los tipos de clientes", {
        variant: "error",
      });
    }
  };

  // Único efecto que dispara fetchSolicitudes.
  // Todas las vías (página, recargar, catálogos, itemsPerPage) pasan por aquí
  // para garantizar que loadingConsulta siempre se resetea en el .finally().
  // La condición guard evita llamadas antes de que los catálogos estén listos.
  useEffect(() => {
    if (tipoConsulta.length > 0 && dataBodega.length > 0) {
      fetchSolicitudes().finally(() => {
        setLoadingConsulta(false);
      });
    } else {
      setLoadingConsulta(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentPage,
    itemsPerPage,
    recargar,
    tipoConsulta,
    dataBodega
  ]);

  // Función para el botón de consultar
  const handleConsultar = () => {
    setLoadingConsulta(true);
    setCurrentPage(1); // Resetear a la primera página
    setRecargar(prev => !prev); // Forzar recarga
  };

  useEffect(() => {

    // Resetear página si cambian filtros
    setCurrentPage(1);
  }, [
    tipoConsulta,
    selectedBodega,
    estado,
    fechaInicio,
    fechaFin,
    selectedVendedor,
    analistaSelected,
    solicitud,
    documental,
    telefonica,
    domicilio,
    laboral,
    nombre,
    numeroSolicitud,
    cedula,
    motivoContinuidad,
    tipoFirmaElectronica,
    redSocial,
    tipoClienteFiltro
  ]);
  const [openDialog3, setOpenDialog3] = useState(false);
  const [analistasDisponibles, setAnalistasDisponibles] = useState([]);
  const [analistaSeleccionado, setAnalistaSeleccionado] = useState(null);
  const [filaActual, setFilaActual] = useState(null);
  const [openDialogConfirmar, setOpenDialogConfirmar] = useState(false); // Confirmación
  const [openDialogOperador, setOpenDialogOperador] = useState(false);
  const [operadorSeleccionado, setOperadorSeleccionado] = useState(null);
  const [openDialogConfirmarOperador, setOpenDialogConfirmarOperador] = useState(false); // Confirmación operador  // Nuevo: Confirmar asignación de operador y notificar

  const handleConfirmarAsignacion = async () => {
    try {
      setOpenDialogConfirmar(false);

      if (analistaSeleccionado === filaActual.idAnalista) {
        enqueueSnackbar("El analista seleccionado es el mismo que el actual.", {
          variant: "error",
        });
        setAnalistaSeleccionado(null)
        return;
      }

      await updateAnalista(filaActual, analistaSeleccionado);
      await fetchConsultaYNotifica(filaActual.id, filaActual, {
        title: "¡Nueva solicitud enviada a revisión! 👀",
        body: `Revisa la solicitud de crédito ${filaActual.numeroSolicitud} de 🧑‍💼 ${filaActual.PrimerNombre} ${filaActual.ApellidoPaterno} con CI. ${filaActual.cedula}
    Fecha: ${fechaHoraEcuador}`,
        type: "success",
        empresa: "CREDI",
        url: "", // Opcional
        tipo: "analista",
      });
      enqueueSnackbar("Analista actualizado correctamente", {
        variant: "success",
      });
      setAnalistaSeleccionado(null)
    } catch (error) {
      console.error("Error al confirmar la asignación:", error);
      enqueueSnackbar("Ocurrió un error al actualizar el analista.", {
        variant: "error",
      });
    }
  };


  const handleEditarAnalista = (fila) => {
    setFilaActual(fila);
    fetchAnalistas();
  };


  const handleEditarOperador = (fila) => {
    setFilaActual(fila);
    fetchOperador();
    setOpenDialogOperador(true);
  };

  // Confirmación de operador, igual que analista
  const handleConfirmarAsignacionOperador = async () => {
    try {
      setOpenDialogOperador(false);


      if (operadorSeleccionado === filaActual.idOperador) {
        enqueueSnackbar("El operador seleccionado es el mismo que el actual.", { variant: "info" });
        return;
      }

      await updateOperador(filaActual, operadorSeleccionado);
      await fetchConsultaYNotifica(filaActual.id, filaActual, {
        title: "¡Nueva solicitud asignada!",
        body: `Revisa la solicitud de crédito ${filaActual.NumeroSolicitud} de 🧑‍💼 ${filaActual.PrimerNombre} ${filaActual.ApellidoPaterno} - ${filaActual.cedula} de ${filaActual.almacen}  \nFecha: ${new Date().toLocaleString("es-EC")}`,
        type: "success",
        empresa: "CREDI",
        url: "",
        tipo: "operador",
      });
      enqueueSnackbar("Operador actualizado correctamente", {
        variant: "success",
      });
      setOperadorSeleccionado(null);
    } catch (error) {
      console.error("Error al confirmar la asignación de operador:", error);
      enqueueSnackbar("Ocurrió un error al actualizar el operador.", {
        variant: "error",
      });
    }
  };


  const fetchAnalistas = async () => {
    // Verificar si ya existe en caché
    if (cacheAnalistas) {
      const activos = cacheAnalistas.filter((a) => a.Estado === 1);
      setAnalistasDisponibles(activos);
      setOpenDialog3(true);
      return;
    }

    try {
      const response = await axios.get(APIURL.analistacredito(), {
        headers: { method: "GET", cache: "no-store" },
      });

      // Guardar en caché
      setCacheAnalistas(response.data);

      const activos = response.data.filter((a) => a.Estado === 1);
      setAnalistasDisponibles(activos);
      setOpenDialog3(true);
    } catch (error) {
      console.error("Error al obtener analistas:", error);
    }
  };

  const updateAnalista = async (fila, numero) => {

    try {

      await axios.patch(
        APIURL.update_solicitud(fila.id),
        {
          idAnalista: numero,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }

    fetchInsertarDatos2(8, fila, 1)
  };

  const updateOperador = async (fila, numero) => {

    try {
      await axios.patch(
        APIURL.update_solicitud(fila.id),
        {
          idOperador: numero,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }

    fetchInsertarDatos3(9, fila, 1)
  };

  const [operadores, setOperadores] = useState([]); 
  
  const [tiposFirmaElectronica, setTiposFirmaElectronica] = useState([]);

  const fetchTipoFirmaElectronica = async () => {
    try {
      const response = await axios.get(APIURL.getTipoFirmaElectronica());
      if (response.status === 200) {
        setTiposFirmaElectronica(response.data);
      }
    } catch (error) {
      console.error("Error al obtener tipos de firma electrónica:", error);
    }
  };

  const fetchOperador = async () => {
    // Verificar si ya existe en caché
    if (cacheOperadores) {
      setOperadores(cacheOperadores);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(APIURL.getUsuarioPorROL(16), {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        // Guardar en caché
        setCacheOperadores(response.data);
        setOperadores(response.data);
      }
    } catch (error) {
      console.error("Error al obtener operadores:", error);
    }
  };

  const fetchSolicitudes = async () => {
    // Primero se obtiene el array de bodegas
    let bodegasId = [];
    // Verificar que tipoConsulta y dataBodega no estén vacíos
    if (tipoConsulta.length === 0 || dataBodega.length === 0) return;

    try {
      const token = localStorage.getItem("token");
      const offset = (currentPage - 1) * itemsPerPage;

      // Si selectedBodega es "todos", pasar un array vacío (esto también se puede ajustar según el comportamiento deseado)
      if (selectedBodega !== "todos") {
        // Si selectedBodega tiene un valor específico, tomarlo como un array
        bodegasId = [selectedBodega];
      } else {
        // Si es "todos", se puede pasar un array vacío o la lógica que desees
        bodegasId = bodegasIds; // Aquí se asigna el array de bodegas
      }

      if (userData?.idGrupo === 23) {
        const vendedorFiltrado = vendedores.find(
          (v) => v?.Codigo?.trim() === userData?.Nombre?.trim()
        );

        if (!vendedorFiltrado) {
          // Si no hay vendedor valido no se hace la consulta 
          setDatos([]);
          setTotal(0);
          setTotalPages(1);
          return;
        }
      }


      const response = await axios.post(
        APIURL.getCreSolicitudCredito(), // URL del endpoint POST
        {
          limit: itemsPerPage,
          offset: offset,
          fechaInicio: fechaInicio,       // debe ser string en formato ISO
          fechaFin: fechaFin,             // debe ser string en formato ISO
          bodega: bodegasId,              // array de números
          estado: estado === "todos" ? 0 : estado,
          vendedor: selectedVendedor === "todos" ? 0 : selectedVendedor,
          analista: analistaSelected === "todos" ? 0 : analistaSelected,
          EstadoSolicitud: solicitud === "Todos" ? 0 : solicitud,
          EstadoDocumental: documental === "Todos" ? 0 : documental,
          EstadoTelefonica: telefonica === "Todos" ? 0 : telefonica,
          EstadoDomicilio: domicilio === "Todos" ? 0 : domicilio,
          EstadoLaboral: laboral === "Todos" ? 0 : laboral,
          nombres: nombre?.trim() || undefined,
          numeroSolicitud: numeroSolicitud?.trim() || undefined,
          cedula: cedula?.trim() || undefined,
          operador: operadorSelected === "todos" ? 0 : operadorSelected,
          motivoContinuidad: motivoContinuidad ? 1 : 0,
          tieneRespaldosPendientes: tieneRespaldosPendientes ? 1 : 0,
          estadoRespaldosPendientes: estadoRespaldosPendientes === "Todos" ? 0 : estadoRespaldosPendientes,
          // "todos" no se envía (sin filtro); 0 = sin firma, 1 = Yupana, 2 = Banco Solidario
          TipoFirmaElectronica: tipoFirmaElectronica === "todos" ? undefined : Number(tipoFirmaElectronica),
          idTipoCliente: tipoClienteFiltro === "todos" ? 0 : Number(tipoClienteFiltro),
          idRedesSociales: redSocial === "todos" ? 0 : redSocial,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );


      if (response.status === 201) {
        const totalRecords = response.data.total;
        const totalPages = Math.ceil(totalRecords / itemsPerPage);

        // Mapeo de datos con fetchVendedor
        console.log("DEBUG RESPONSE.DATA.DATA:", response.data.data[0]);
        const datos = await Promise.all(
          response.data.data.map(async (item) => {
            const vendedorNombre = await fetchVendedor(item.idVendedor);
            return {
              raw: item,
              id: item.idCre_SolicitudWeb,
              PDFTerrena: item.PDFTerrena,
              CuotasGratis: item.CuotasGratis,
              NumeroSolicitud: item.NumeroSolicitud,
              TipoFirmaElectronica: item.TipoFirmaElectronica,
              nombre: `${item.PrimerNombre} ${item.SegundoNombre} ${item.ApellidoPaterno} ${item.ApellidoMaterno}`,
              PrimerNombre: item.PrimerNombre,
              SegundoNombre: item.SegundoNombre,
              ApellidoPaterno: item.ApellidoPaterno,
              ApellidoMaterno: item.ApellidoMaterno,
              cedula: item.Cedula,
              bodega: item.Bodega,
              almacen:
                dataBodega.find((bodega) => bodega.value === item.Bodega)
                  ?.label || "Desconocido",
              vendedor: vendedorNombre,
              consulta:
                tipoConsulta.find((tipo) => tipo.id === item.idCompraEncuesta)
                  ?.descripcion || "CLIENTE NO APLICA",
              estado:
                item.Estado === 1
                  ? "PRE-APROBADO"
                  : item.Estado === 2
                    ? "APROBADO"
                    : item.Estado === 3
                      ? "ANULADO"
                      : item.Estado === 4
                        ? "RECHAZADO"
                        : item.Estado === 5
                          ? "NO APLICA"
                          : item.Estado === 6
                            ? "FACTURADO"
                            : item.Estado === 7
                              ? "CADUCADO"
                              : item.Estado === 8
                                ? "NOTA DE CRÉDITO"
                                : item.Estado === 9
                                  ? "NOTA DE CRÉDITO AUTOMÁTICA"
                                  : item.Estado === 10
                                    ? "RE-PROCESO"
                                    : "Desconocido",
              imagen: item.Foto,
              Estado: item.Estado,
              celular: item.Celular,
              email: item.Email,
              fecha: item.Fecha,
              afiliado: item.bAfiliado ? "Sí" : "No",
              tieneRuc: item.bTieneRuc ? "Sí" : "No",
              tipoCliente: tipoClienteMap[item.idTipoCliente] || "NO APLICA",
              idEstadoVerificacionDocumental:
                item.idEstadoVerificacionDocumental,
              RespaldosPendientesEstado: item.RespaldosPendientesEstado,
              idCompraEncuesta: item.idCompraEncuesta,
              idRedesSociales: item.idRedesSociales,
              TieneFacturaYupana: item.TieneFacturaYupana === true,
              idEstadoVerificacionSolicitud: item.idEstadoVerificacionSolicitud,
              idEstadoVerificacionTelefonica:
                item.idEstadoVerificacionTelefonica,
              idEstadoVerificacionTerrena: item.idEstadoVerificacionTerrena,
              resultado: item.Resultado,
              entrada: item.Entrada,
              Domicilio: item.TerrenoDomicilio,
              Laboral: item.TerrenoLaboral,
              CodigoDactilar: item.CodDactilar,
              idEstadoVerificacionDomicilio: item.idEstadoVerificacionDomicilio,
              idCompra: item.idCompra,
              idAnalista: item.idAnalista,
              Operador: item.idOperador,
              idProducto: Number(item.idProductos) === 1
                ? "COMBOS"
                : Number(item.idProductos) === 2
                  ? "LAVADORA"
                  : Number(item.idProductos) === 3
                    ? "MOVILIDAD"
                    : Number(item.idProductos) === 4
                      ? "PORTATIL"
                      : Number(item.idProductos) === 5
                        ? "REFRIGERADOR"
                        : Number(item.idProductos) === 6
                          ? "TELEVISOR"
                          : Number(item.idProductos) === 8
                            ? "IPHONE"
                            : "DESCONOCIDO",
              idVendedor: item.idVendedor,
              idMotivoContinuidad: item.idMotivoContinuidad,
              FechaAfiliacionIngreso: item.FechaIngreso,
              FechaAfiliacionHasta: item.FechaAfiliacionHasta,
              idFirmaElectronica: item.idFirmaElectronica,
              idEstadoAnalisisDeIdentidad: item.idEstadoAnalisisDeIdentidad,
              sCre_SolicitudWeb: item.sCre_SolicitudWeb,
              sEQFX_IdentificacionConsultada: item.sEQFX_IdentificacionConsultada,
              iClienteReiterativo: item.idClienteReiterativo,
              iClienteVigente: item.idClienteVigente,

            };
          })
        );
        setDatos(datos);
        setTotal(totalRecords);
        setTotalPages(totalPages);
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Obtener vendedor
  const fetchVendedor = async (idVendedor) => {
    try {
      const response = await axios.get(APIURL.getVendedor(idVendedor), {
        headers: { method: "GET", cache: "no-store" },
      });

      if (response.status === 200) {
        const vendedor = response.data;
        return (
          `${vendedor.PrimerNombre || ""} ${vendedor.SegundoNombre || ""} ${vendedor.ApellidoPaterno || ""
            } ${vendedor.ApellidoMaterno || ""}`.trim() || "No disponible"
        );
      }
    } catch (error) {
      console.error("Error fetching vendedor data:", error);
      return "No disponible";
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setDataBodega(
        data.map((item) => ({
          value: item.b_Bodega,
          label: item.b_Nombre,
        }))
      );
    }
  }, [data]);

  //// patch solicitud cuando se aprueba la solicitud de credito

  // Aprobación (2) / rechazo (4) manual de identidad: el backend cambia el
  // estado, deja la trazabilidad (Tipo 6) y registra el método en Cre_VerificacionIdentidad.
  const verificacionManual = async (idSolicitud, aprobar) => {
    try {
      await axios.post(APIURL.postVerificacionManual(), { idSolicitud, aprobar });
      enqueueSnackbar("Solicitud actualizada correctamente.", { variant: "success" });
    } catch (error) {
      console.error("Error en la verificación manual:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", { variant: "error" });
    }
  };





  const handledocumentos = (registro) => {
    const stateData = {
      id: registro.id,
      NumeroSolicitud: registro.NumeroSolicitud,
      nombre: registro.nombre,
      cedula: registro.cedula,
      fecha: registro.fecha,
      almacen: registro.almacen,
      foto: registro.imagen,
      vendedor: registro.vendedor,
      consulta: registro.consulta,
      idEstadoVerificacionDocumental: registro.idEstadoVerificacionDocumental,
      estadoVerifD: registro.idEstadoVerificacionDocumental,
      idFirmaElectronica: registro.idFirmaElectronica,
      sCre_SolicitudWeb: registro.sCre_SolicitudWeb,
      idEstadoVerificacionSolicitud: registro.idEstadoVerificacionSolicitud,
      Estado: registro.Estado,
      TipoFirmaElectronica: registro.TipoFirmaElectronica,
      idCompra: registro.idCompra,
      TieneFacturaYupana: registro.TieneFacturaYupana,
      permisos: permisos,
    };

    if (Number(registro.TipoFirmaElectronica) === 1 && (registro.TieneFacturaYupana || Number(registro.Estado) === 6) && Number(registro.idEstadoVerificacionSolicitud) === 12) {
      navigate("/gestorDocumentosFirma", {
        replace: true,
        state: stateData,
      });
      return;
    }

    if (
      (registro.idEstadoVerificacionDocumental === 1 || registro.idEstadoVerificacionDocumental === 3) &&
      Number(registro.TipoFirmaElectronica) === 2
    ) {
      navigate("/documental-banco-solidario", {
        replace: true,
        state: stateData,
      });
      return;
    }

    if (
      registro.idEstadoVerificacionDocumental === 2 ||
      registro.idEstadoVerificacionDocumental === 4
    ) {
      navigate("/gestorDocumentos", {
        replace: true,
        state: stateData,
      });
    } else {
      navigate("/documental", {
        replace: true,
        state: stateData,
      });
    }
  };

  const handleTelefonica = (registro) => {
    navigate("/telefonicaList", {
      replace: true,
      state: {
        id: registro.id,
        NumeroSolicitud: registro.NumeroSolicitud,
        nombre: registro.nombre,
        cedula: registro.cedula,
        fecha: registro.fecha,
        almacen: registro.almacen,
        foto: registro.imagen,
        vendedor: registro.vendedor,
        consulta: registro.consulta,
        idEstadoVerificacionTelefonica: registro.idEstadoVerificacionTelefonica,
        TipoFirmaElectronica: registro.TipoFirmaElectronica,
        permisos: permisos,
        idVendedor: registro.idVendedor,
        idAnalista: registro.idAnalista
      },
    });
  };

  const handlesolicitud = (registro) => {
    if (Number(registro.TipoFirmaElectronica) === 1) {
      navigate("/nueva-solicitud-yupana", {
        state: {
          continuarSolicitud: true,
          solicitudData: registro,
          pasoResumen: true
        }
      });
    } else {
      navigate("/solicitudgrande", {
        replace: true,
        state: {
          data: registro,
        },
      });
    }
  };

  const handleOpenFirmaElectronica = async (registro) => {
    await validaPrefactura(registro.cedula, registro.bodega);
    if (Number(registro.TipoFirmaElectronica) === 2) {
      await validaPrefacturaAprobadaBS(registro.cedula, registro.bodega);
    }
    setSelectedRow(registro);
    setModalFirmaOpen(true);
  };



  const handleOpenDialog = async (row) => {
    const [cuotaDato, solicitudGrande] = await Promise.all([
      fetchCuota(row.id),
      axios.get(APIURL.getSolicitudGrandeporId(row.id))
        .then((response) => response.data)
        .catch(() => null),
    ]);

    setSelectedRow({
      ...row,
      CuotaAsignada: cuotaDato?.CuotaAsignada ?? null,
      email: solicitudGrande?.Email ?? row.email,
    });
    setView(true);
    const [tipo1, tipo2, tipo3, tipo4, tipo5] = await Promise.all([
      fetchTiempSolicweb(1, row.id, "10,12"),  //solicitudes
      fetchTiempSolicweb(2, row.id, "2,3"),    //telefonica 
      fetchTiempSolicweb(3, row.id, "2,4"),    //documental
      fetchTiempSolicweb(4, row.id, "1"),      //domicilio
      fetchTiempSolicweb(5, row.id, "1")       //laboral
    ]);

    await validaPrefactura(row.cedula, row.bodega);

    if (Number(row.TipoFirmaElectronica) === 2) {
      await validaPrefacturaAprobadaBS(row.cedula, row.bodega);
    }

    const resultados = {
      tipo1, tipo2, tipo3, tipo4, tipo5
    }
    setfechaTiempos(resultados);
  };

  const handleOpenDialogDomicilioLaboral = async (row, tipo) => {

    setSelectedRow(row);
    setTipoVerificacion(tipo);
    setShowModalCorrecion(true);
  };

  const handleOpenCambioBodega = async (row) => {
    setSelectedRow(row);
    setOpen(true);
  }

  const handleOpenObservacionCredito = async (row) => {
    setSelectedRow(row);
    setObservacionModalAbierto(true);
  };

  const handleCloseDialog = () => {
    setView(false);
    setSelectedRow(null);
    setPreviewUrl(null); // Limpiar imagen temporal
    setFileToUpload(null);
  };

  const handleOpenAuditoriaIntegral = (row) => {
    setAuditoriaRow(row);
    setOpenAuditoriaIntegral(true);
  };

  const handleSolictud = () => {
    navigate("/solicitud", { replace: true });
  };

  const handleSolictudYupana = () => {
    navigate("/nueva-solicitud-yupana", { replace: true });
  };

  const handleNuevaSolicitud = () => {
    navigate("/nuevaSolicitud", { replace: true });
  }

  // Función para cambiar de página
  const changePage = (page) => {
    setCurrentPage(page);
  };

  const handleOpenModal = (data) => {
    setUserSolicitudData(data);

    setOpenLocationModal((prevState) => !prevState);
  };

  const handleCorreccion = async (observacion) => {
    const isDomicilio = TipoVerificacion === "domicilio";

    // Determinar los valores dinámicos
    const camposeleccionado = isDomicilio ? "Domicilio" : "Laboral";
    const campo = isDomicilio ? "TerrenoDomicilio" : "TerrenoLaboral";
    const idTipo = isDomicilio ? 4 : 5;
    const valorActual = selectedRow?.[camposeleccionado];
    // Convertir booleano a número (1 o 0)
    const nuevoValor = !valorActual ? 1 : 0;
    const idTipoVerificacion = nuevoValor ? 9 : 8; // 8 para corrección, 9 para aprobado

    // Actualizar estado (activar/desactivar)
    await patchSolicitudEstadoyResultado(selectedRow?.id, { [campo]: nuevoValor });

    // Insertar datos de rechazo
    await fetchInsertarDatosRechazo(idTipo, selectedRow?.id, idTipoVerificacion, observacion);

    handleCloseDialog();
    setShowModalCorrecion(false);
    setRecargar((prev) => !prev);
  };

  const handleConfirmarBodega = async ({ nota, bodegaSeleccionada }) => {
    // Lógica para manejar la confirmación de cambio de bodega


    await patchSolicitudEstadoyResultado(selectedRow?.id, { Bodega: bodegaSeleccionada });
    await fetchInsertarDatosRechazo(1, selectedRow?.id, 27, nota);

    setRecargar((prev) => !prev);
    setOpen(false);
  };

  const handleConfirmarObservacion = async (observacion) => {
    // await fetchInsertarDatosRechazo(7, selectedRow?.id, 29, observacion);
    // console.log("Observacion credito:", observacion.nota);

    await fetchInsertarDatosRechazo(10, selectedRow?.id, 1, observacion.nota);
    setShowModalRechazo(false);
    setRecargar((prev) => !prev);
  }

  const handleEquifax = () => {
    navigate("/equifaxx", {
      replace: true,
      state: {
        nombre: selectedRow.nombre,
        cedula: selectedRow.cedula,
        Fecha: selectedRow.fecha,
        sEQFX_IdentificacionConsultada: selectedRow.sEQFX_IdentificacionConsultada,
      },
    });
  }

  // filtros 
  const limpiarFiltros = () => {
    setFechaInicio(date15DaysAgoStr);
    setFechaFin(today);
    setAnalistaSelected("todos");
    setOperadorSelected("todos");
    setEstado("todos");
    setSolicitud("Todos");
    setDocumental("Todos");
    setTelefonica("Todos");
    setDomicilio("Todos");
    setLaboral("Todos");
    setCedula('')
    setNombre('')
    setNumeroSolicitud('')
    setMotivoContinuidad(false)
    setTieneRespaldosPendientes(false)
    setEstadoRespaldosPendientes("Todos")
    setTipoFirmaElectronica("todos")
    setRedSocial("todos")
    setTipoClienteFiltro("todos")

    sessionStorage.removeItem('filtroIniFecha');
    sessionStorage.removeItem('filtroFinFecha');
    sessionStorage.removeItem('filtroAnalista');
    sessionStorage.removeItem('filtroOperador');
    sessionStorage.removeItem('filtroEstado');
    sessionStorage.removeItem('filtroSolicitud');
    sessionStorage.removeItem('filtroDocumental');
    sessionStorage.removeItem('filtroTelefonica');
    sessionStorage.removeItem('filtroDomicilio');
    sessionStorage.removeItem('filtroLaboral');
    sessionStorage.removeItem('filtroCedula')
    sessionStorage.removeItem('filtroNombre')
    sessionStorage.removeItem('filtroNumSolicitud')
    sessionStorage.removeItem('filtroMotivoContinuidad')
    sessionStorage.removeItem('filtroTieneRespaldosPendientes')
    sessionStorage.removeItem('filtroEstadoRespaldosPendientes')
    sessionStorage.removeItem('filtroTipoFirmaElectronica')
    sessionStorage.removeItem('filtroRedSocial')
    sessionStorage.removeItem('filtroTipoCliente')
    if (userData?.idGrupo !== 23) {
      setSelectedVendedor("todos");
      setSelectedBodega("todos");
      sessionStorage.removeItem('filtroVendedor');
      sessionStorage.removeItem('filtroBodega');
    }
  };


  useEffect(() => {
    if (userData?.idGrupo === 23) {
      if (bodegas.length > 0) {
        const primeraBodega = bodegas[0].b_Bodega;
        setSelectedBodega(primeraBodega);
        sessionStorage.setItem('filtroBodega', primeraBodega);
      }

      const vendedorAutorizado = vendedores.find(
        (v) => v.Codigo === userData.Nombre
      );
      if (vendedorAutorizado) {
        setSelectedVendedor(vendedorAutorizado.idPersonal);
        sessionStorage.setItem('filtroVendedor', vendedorAutorizado.idPersonal);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.idGrupo, userData?.Nombre, bodegas, vendedores]);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleRechazar = async (observacion) => {
    patchSolicitudEstadoyResultado(selectedRow?.id, { Estado: 4, Resultado: 0, Observacion: observacion });
    //patchSolicitudEstadoyResultado(selectedRow?.id, { Resultado: 0 });
    // fetchInsertarDatos(6, selectedRow?.id, 4);
    fetchInsertarDatosRechazo(6, selectedRow?.id, 4, observacion)
    handleCloseDialog()
    setShowModalRechazo(false); // <-- Cierra el modal de rechazo siempre que abras el de detalles

    setRecargar(prev => !prev);
  }

  const handleReproceso = async (observacion) => {
    // 10 solo en nueva solicitud no debe cambiar nada para yupana
    const isYupana = selectedRow?.origen?.toLowerCase() === 'yupana' || selectedRow?.Origen?.toLowerCase() === 'yupana' || selectedRow?.idTipoCliente === 13;
    const nuevoEstado = isYupana ? 4 : 10;


    patchSolicitudEstadoyResultado(selectedRow?.id, { Estado: nuevoEstado, Resultado: 0, Observacion: observacion });
    fetchInsertarDatosRechazo(6, selectedRow?.id, nuevoEstado, observacion);
    handleCloseDialog();
    setShowModalReproceso(false);

    setRecargar(prev => !prev);
  }



  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen overflow-auto">
      <FiltrosListado
        fechaInicio={fechaInicio} setFechaInicio={setFechaInicio}
        fechaFin={fechaFin} setFechaFin={setFechaFin}
        userData={userData}
        selectedBodega={selectedBodega} setSelectedBodega={setSelectedBodega} bodegas={bodegas}
        selectedVendedor={selectedVendedor} setSelectedVendedor={setSelectedVendedor} vendedores={vendedores}
        analistaSelected={analistaSelected} setAnalistaSelected={setAnalistaSelected} analistas={analistas}
        operadorSelected={operadorSelected} setOperadorSelected={setOperadorSelected} operadores={operadores}
        estado={estado} setEstado={setEstado}
        solicitud={solicitud} setSolicitud={setSolicitud}
        documental={documental} setDocumental={setDocumental}
        telefonica={telefonica} setTelefonica={setTelefonica}
        domicilio={domicilio} setDomicilio={setDomicilio}
        laboral={laboral} setLaboral={setLaboral}
        cedula={cedula} setCedula={setCedula}
        nombre={nombre} setNombre={setNombre}
        numeroSolicitud={numeroSolicitud} setNumeroSolicitud={setNumeroSolicitud}
        motivoContinuidad={motivoContinuidad} setMotivoContinuidad={setMotivoContinuidad}
        tieneRespaldosPendientes={tieneRespaldosPendientes} setTieneRespaldosPendientes={setTieneRespaldosPendientes}
        estadoRespaldosPendientes={estadoRespaldosPendientes} setEstadoRespaldosPendientes={setEstadoRespaldosPendientes}
        tipoFirmaElectronica={tipoFirmaElectronica} setTipoFirmaElectronica={setTipoFirmaElectronica} tiposFirmaElectronica={tiposFirmaElectronica}
        redSocial={redSocial} setRedSocial={setRedSocial}
        tipoClienteFiltro={tipoClienteFiltro} setTipoClienteFiltro={setTipoClienteFiltro} tiposCliente={tiposCliente}
        handleConsultar={handleConsultar} loadingConsulta={loadingConsulta} limpiarFiltros={limpiarFiltros}
        puedeCrearSolicitud={puedeCrearSolicitud} handleSolictud={handleSolictud}
        puedeCrearSolicitudNueva={puedeCrearSolicitudNueva} handleNuevaSolicitud={handleNuevaSolicitud}
        imprimirInforme={imprimirInforme} setOpenModalExcel={setOpenModalExcel}
        crearYupana={crearYupana} handleSolictudYupana={handleSolictudYupana}
      />


      <div className="p-6 bg-gray-50 rounded-xl">
        <div className="bg-white shadow-lg rounded-xl overflow-hidden border border-gray-200">
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 750,
              width: "100%",
              boxShadow: "none",
              margin: "0.5rem auto",
            }}
          >
            <Table
              stickyHeader
              sx={{
                borderCollapse: "collapse",
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    "& th": {
                      backgroundColor: "#f1f5f9", // slate-100
                      color: "#475569", // slate-600
                      fontSize: "0.6875rem", // 11px
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      padding: "6px 8px",
                      borderBottom: "1px solid #e2e8f0",
                    },
                  }}
                >
                  <TableCell align="center"> <span style={{ color: '#ec4899' }}></span> </TableCell>
                  <TableCell align="center">N° Solicitud</TableCell>
                  <TableCell align="center">Cliente</TableCell>
                  <TableCell align="center">Cédula</TableCell>
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Almacén</TableCell>
                  <TableCell align="center">Vendedor</TableCell>
                  <TableCell align="center">Estado</TableCell>
                  <TableCell align="center">Entrega Producto</TableCell>
                  <TableCell align="center">Tipo de Cliente</TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center">Resultado</TableCell>
                  {/* <TableCell align="center">Entradas</TableCell> */}
                  <TableCell align="center">Detalles</TableCell>
                  <TableCell align="center">Identificador</TableCell>
                  <TableCell align="center">Digital</TableCell>
                  <TableCell align="center">Info</TableCell>
                  <TableCell align="center">Solicitudes</TableCell>
                  <TableCell align="center">Documental</TableCell>
                  <TableCell align="center">Telefonica</TableCell>
                  <TableCell align="center">Domicilio</TableCell>
                  <TableCell align="center">Laborales</TableCell>
                  <TableCell align="center">Analista</TableCell>
                  <TableCell align="center">Operador</TableCell>
                  <TableCell align="center"></TableCell>

                </TableRow>
              </TableHead>

              <TableBody sx={{ marginTop: 0 }}>
                {datos.map((data, index) => (
                  <SolicitudTableRow
                    key={data.id}
                    data={data}
                    index={index}
                    analistas={analistas}
                    operadores={operadores}
                    popoverData={popoverData}
                    clienteEstados={clienteEstados}
                    setIsOpenMotivo={setIsOpenMotivo}
                    setDataInforme={setDataInforme}
                    setCurrentAction={setCurrentAction}
                    setCurrentData={setCurrentData}
                    setOpenDialog2={setOpenDialog2}
                    setIsOpenPdf={setIsOpenPdf}
                    handleOpenObservacionCredito={handleOpenObservacionCredito}
                    handlePopoverOpen={handlePopoverOpen}
                    handlePopoverClose={handlePopoverClose}
                    handleOpenCambioBodega={handleOpenCambioBodega}
                    handleOpenDialog={handleOpenDialog}
                    handleOpenFirmaElectronica={handleOpenFirmaElectronica}
                    handleOpenAuditoriaIntegral={handleOpenAuditoriaIntegral}
                    handlesolicitud={handlesolicitud}
                    handledocumentos={handledocumentos}
                    handleTelefonica={handleTelefonica}
                    handleOpenModalVerificacion={handleOpenModalVerificacion}
                    handleOpenDialogDomicilioLaboral={handleOpenDialogDomicilioLaboral}
                    handleEditarAnalista={handleEditarAnalista}
                    handleEditarOperador={handleEditarOperador}
                    permisosFila={{
                      permisoAgregarObservacionCredito,
                      permisoCambiarBodega,
                      permisoAprobarEstado,
                      tienePermisoEditarAnalista,
                      permisoEditarOperador,
                      estadoDeshabilitadoporPermisos,
                      estadoDeshabilitadoDocumental,
                      estadoDeshabilitadotelefonica,
                      permisoEditarVerificacionTerreno,
                      permisoReasignarDomicilio,
                      permisoReasignarLaboral,
                      puedeDescargarDocumentosBS,
                    }}
                    estaDeshabilitado={estaDeshabilitado}
                    verificacionSolicitud={verificacionSolicitud}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

      </div>

      {/* Cuadro de diálogo para ver detalles */}
      <VerDetallesModal
        open={view}
        onClose={handleCloseDialog}
        selectedRow={selectedRow}
        fechaTiempos={fechaTiempos}
        previewUrl={previewUrl}
        fileToUpload={fileToUpload}
        inputFileRef={inputFileRef}
        openCameraModal={openCameraModal}
        setOpenCameraModal={setOpenCameraModal}
        setImagenCapturada={setImagenCapturada}
        setPreviewUrl={setPreviewUrl}
        setFileToUpload={setFileToUpload}
        ExistPrefactura={ExistPrefactura}
        isPrefacturaAprobadaBS={isPrefacturaAprobadaBS}
        showModalRechazo={showModalRechazo}
        setShowModalRechazo={setShowModalRechazo}
        showModalReproceso={showModalReproceso}
        setShowModalReproceso={setShowModalReproceso}
        handleReproceso={handleReproceso}
        editarCodDac={editarCodDac}
        editarCodDac2={editarCodDac2}
        formatDateTime={formatDateTime}
        calcularTiempoTranscurrido={calcularTiempoTranscurrido}
        sumarTodosLosTiempos={sumarTodosLosTiempos}
        handleFileChange={handleFileChange}
        handleUploadClick={handleUploadClick}
        fetchImagenRegistroCivil={fetchImagenRegistroCivil}
        handleVerificarIdentidad={handleVerificarIdentidad}
        setErrorModalData={setErrorModalData}
        setErrorModalOpen={setErrorModalOpen}
        handleOpenEditModal={handleOpenEditModal}
        handleOpenEditEmailModal={handleOpenEditEmailModal}
        puedeAprobar={puedeAprobar}
        permitirEquifax={permitirEquifax}
        handleEquifax={handleEquifax}
        handleAbrirVerificacionManual={handleAbrirVerificacionManual}
        handleRechazar={handleRechazar}
        data={data}
        userData={userData}
        fetchEstadoRegcivil={fetchEstadoRegcivil}
      />

      {/* Modal de carga para verificación facial */}
      <VerificacionFacialLoadingModal open={loadingVerificacion} />

      <Dialog open={openDialog3} onClose={() => setOpenDialog3(false)}>
        <DialogTitle>Seleccionar Analista</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel id="select-analista-label">Analista</InputLabel>
            <Select
              labelId="select-analista-label"
              value={analistaSeleccionado || ""}
              onChange={(e) => setAnalistaSeleccionado(e.target.value)}
              label="Analista"
            >
              {analistasDisponibles.map((analista) => (
                <MenuItem key={analista.idUsuario} value={analista.idUsuario}>
                  {analista.Nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog3(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenDialog3(false);
              setOpenDialogConfirmar(true); // Mostrar diálogo de confirmación
            }}
            disabled={!analistaSeleccionado}
          >
            Asignar
          </Button>
        </DialogActions>
      </Dialog>

      {/* confirmacion de cambiar analista  */}
      <Dialog open={openDialogConfirmar} onClose={() => setOpenDialogConfirmar(false)}>
        <DialogTitle>Confirmar acción</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de asignar este analista a la solicitud?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogConfirmar(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              handleConfirmarAsignacion();
            }}
            color="primary"
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* confirmacion de cambiar operador  */}
      <Dialog open={openDialogOperador} onClose={() => setOpenDialogOperador(false)}>
        <DialogTitle>Seleccionar Operador</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel id="select-operador-label">Operador</InputLabel>
            <Select
              labelId="select-operador-label"
              value={operadorSeleccionado || ""}
              onChange={(e) => setOperadorSeleccionado(e.target.value)}
              label="Operador"
            >
              {operadores.map((operador) => (
                <MenuItem key={operador.idUsuario} value={operador.idUsuario}>
                  {operador.Nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogOperador(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenDialogOperador(false);
              setOpenDialogConfirmarOperador(true); // Mostrar diálogo de confirmación de operador
            }}
            disabled={!operadorSeleccionado}
          >
            Asignar
          </Button>
        </DialogActions>
      </Dialog>

      {/* confirmacion de cambiar operador */}
      <Dialog open={openDialogConfirmarOperador} onClose={() => setOpenDialogConfirmarOperador(false)}>
        <DialogTitle>Confirmar acción</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de asignar este operador a la solicitud?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogConfirmarOperador(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              handleConfirmarAsignacionOperador();
              setOpenDialogConfirmarOperador(false);
            }}
            color="primary"
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {totalPages > 1 && (() => {
        // Ventana de páginas con elipsis (ej. 1 … 4 5 6 … 20) — siempre muestra
        // primera, última, y una vecindad alrededor de la página actual, para
        // no listar cientos de botones cuando hay muchas páginas.
        const delta = 1;
        const rango = [];
        for (let i = 1; i <= totalPages; i++) {
          if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
            rango.push(i);
          }
        }
        const paginasConElipsis = [];
        let anterior;
        for (const i of rango) {
          if (anterior !== undefined && i - anterior > 1) {
            paginasConElipsis.push(i - anterior === 2 ? anterior + 1 : "...");
          }
          paginasConElipsis.push(i);
          anterior = i;
        }

        const desde = total === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
        const hasta = Math.min(currentPage * itemsPerPage, total);

        const claseBotonNav = "p-1.5 rounded-lg text-slate-500 hover:bg-slate-100 disabled:opacity-30 disabled:pointer-events-none transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400";

        return (
          <div className="mt-6 bg-white rounded-lg border border-slate-200 shadow-sm px-4 py-3">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <div className="flex items-center justify-between md:justify-start gap-3 order-2 md:order-1">
                <span className="text-sm text-slate-500">
                  Mostrando <span className="font-semibold text-slate-700">{desde}</span>
                  –<span className="font-semibold text-slate-700">{hasta}</span> de{" "}
                  <span className="font-semibold text-slate-700">{total}</span> resultados
                </span>
                <select
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  className="px-2.5 py-1.5 border border-slate-300 rounded-lg text-sm text-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                  {[5, 10, 15, 20].map((value) => (
                    <option key={value} value={value}>
                      {value} / página
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex items-center justify-center gap-1 order-1 md:order-2">
                <button
                  onClick={() => changePage(1)}
                  disabled={currentPage === 1}
                  aria-label="Primera página"
                  className={claseBotonNav}
                >
                  <FirstPageIcon fontSize="small" />
                </button>
                <button
                  onClick={() => changePage(Math.max(currentPage - 1, 1))}
                  disabled={currentPage === 1}
                  aria-label="Página anterior"
                  className={claseBotonNav}
                >
                  <ChevronLeftIcon fontSize="small" />
                </button>

                {paginasConElipsis.map((pagina, i) =>
                  pagina === "..." ? (
                    <span key={`ellipsis-${i}`} className="px-1.5 text-slate-400 text-sm select-none">…</span>
                  ) : (
                    <button
                      key={pagina}
                      onClick={() => changePage(pagina)}
                      aria-current={pagina === currentPage ? "page" : undefined}
                      aria-label={`Ir a la página ${pagina}`}
                      className={`min-w-[32px] h-8 px-2 rounded-lg text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 ${pagina === currentPage
                          ? "bg-blue-600 text-white shadow-sm"
                          : "text-slate-600 hover:bg-slate-100"
                        }`}
                    >
                      {pagina}
                    </button>
                  )
                )}

                <button
                  onClick={() => changePage(Math.min(currentPage + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  aria-label="Página siguiente"
                  className={claseBotonNav}
                >
                  <ChevronRightIcon fontSize="small" />
                </button>
                <button
                  onClick={() => changePage(totalPages)}
                  disabled={currentPage === totalPages}
                  aria-label="Última página"
                  className={claseBotonNav}
                >
                  <LastPageIcon fontSize="small" />
                </button>
              </div>
            </div>
          </div>
        );
      })()}
      <LocationModal
        isOpen={() => handleOpenModal()}
        openLocationModal={openLocationModal}
        locationType={null}
        locationData={null}
        onLocationChange={null}
        userSolicitudData={userSolicitudData}
      />

      <PreDocumentos
        open={openPreDocumentos}
        onClose={() => setOpenPreDocumentos(false)}
        idSolicitud={preDocumentosData?.data?.id}
        infoSoli={preDocumentosData}
        onContinue={async () => {
          setOpenPreDocumentos(false);

          const data = preDocumentosData.data;
          const tipo = preDocumentosData.tipo;
          const idsTerrenas = idsTerrenasMap[data.id];

          if (!idsTerrenas || idsTerrenas.length === 0) {
            setUserSolicitudData(data);
            setTipoVerificacionSeleccionada(tipo);
            setOpenVerificacionModal(true);
            return;
          }

          if (tipo === "domicilio") {
            if (idsTerrenas.idTerrenaGestionDomicilio > 0) {
              setDomicilioData({ ...idsTerrenas, idSolicitud: data.id });
              setDomicilioModalOpen(true);
            } else if (idsTerrenas.idTerrenaGestionDomicilio === 0) {
              await fetchtiemposolicitudesweb(data.id, 4);
              setOpenModalPendiente(true);
            }
            return;
          }

          if (tipo === "trabajo") {
            if (idsTerrenas.idTerrenaGestionTrabajo > 0) {
              setTrabajoData({ ...idsTerrenas, idSolicitud: data.id });
              setTrabajoModalOpen(true);
            } else if (idsTerrenas.idTerrenaGestionTrabajo === 0) {
              await fetchtiemposolicitudesweb(data.id, 5);
              setOpenModalPendiente(true);
            }
            return;
          }
        }}
      />

      <VerificacionTerrenaModal
        isOpen={openVerificacionModal}
        onClose={() => setOpenVerificacionModal(false)}
        userSolicitudData={userSolicitudData}
        userData={userData}
        tipoSeleccionado={tipoVerificacionSeleccionada}
      />

      {/* reasignar verificador */}
      <VerificacionTerrenaModal
        isOpen={openVerificacionModal2}
        onClose={() => setOpenVerificacionModal2(false)}
        userSolicitudData={userSolicitudData2}
        userData={userData}
        tipoSeleccionado={tipoVerificacionSeleccionada2}
        idClienteVerificacion={idsTerrenas.idClienteVerificacion}
        reasignacion={true}
      />

      <DomicilioModal
        openModal={isDomicilioModalOpen}
        closeModal={handleCloseDomicilioModal}
        idsTerrenas={idsTerrenas}
        idSolicitud={domicilioData?.idSolicitud}
        datosCliente={domicilioData?.cliente}
      />

      <TrabajoModal
        openModal={isTrabajoModalOpen}
        closeModal={handleCloseTrabajoModal}
        idsTerrenas={idsTerrenas}
        idSolicitud={trabajoData?.idSolicitud}
        datosCliente={trabajoData?.cliente}
      />

      <ListVerifDomicilioModal
        openModal={listVerifDomiciModal}
        closeModal={handleCloseVerifDomModal}
        datosCliente={domicilioData}
        userData={userData}
        permisos={permisos}
      />

      <ListVerifLaboralModal
        openModal={listVerifLaborModal}
        closeModal={handleCloseVerifLabModal}
        datosCliente={trabajoData}
        userData={userData}
        permisos={permisos}
      />

      <ModalCorreccion
        isOpen={showModalCorrecion}
        onClose={() => setShowModalCorrecion(false)}
        onConfirm={handleCorreccion}
        solicitudData={selectedRow}
        Titulo='Enviar a Corrección'

        mensajePrincipal={`¿Deseas cambiar la verificación ${TipoVerificacion === "domicilio" ? "domiciliaria" : "laboral"
          } de ${selectedRow
            ? (TipoVerificacion === "domicilio"
              ? selectedRow.Domicilio
              : selectedRow.Laboral)
              ? "ACTIVADA"
              : "DESACTIVADA"
            : ""
          } a ${selectedRow
            ? (TipoVerificacion === "domicilio"
              ? selectedRow.Domicilio
              : selectedRow.Laboral)
              ? "DESACTIVADA"
              : "ACTIVADA"
            : ""
          }?`}
      />


      <ObservacionCredito
        isOpen={observacionModalAbierto}
        onClose={() => setObservacionModalAbierto(false)}
        onConfirm={handleConfirmarObservacion}
        solicitudData={selectedRow}
        mensajePrincipal="Agrega un comentario u observación sobre el crédito seleccionado."
      />
      <CambioBodega
        isOpen={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirmarBodega}
        solicitudData={selectedRow}
        mensajePrincipal="Selecciona la nueva bodega de destino para esta solicitud."
        Titulo="Cambiar bodega"
        ListaBodega={bodegas}
      />

      {openModalPendiente && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-lg rounded-lg shadow-xl p-6 relative">

            {/* Icono y título */}
            <div className="flex items-center mb-5">
              <div className="bg-yellow-100 text-yellow-600 rounded-full p-2 mr-3">

              </div>
              <h2 className="text-lg font-semibold text-gray-800">
                Verificación pendiente
              </h2>
            </div>

            {/* Cuerpo del mensaje */}
            <p className="text-sm text-gray-700 mb-4">
              Esta solicitud está pendiente de verificación por parte del verificador asignado:
              <span className="ml-2 font-medium text-blue-700">
                {clienteEstados.length > 0 ? clienteEstados[0].Telefono : "N/A"}
              </span>
            </p>

            {/* Acción para reasignar (si tiene permiso) */}
            {permisoReasignarVerificador() && (
              <div className="flex justify-end mt-2">
                <button
                  onClick={() => {
                    setOpenVerificacionModal2(true);
                    setOpenModalPendiente(false);
                  }}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition"
                >
                  Reasignar Verificador
                </button>
              </div>
            )}

            {/* Línea divisoria */}
            <hr className="my-4" />

            {/* Acciones inferiores */}
            <div className="flex justify-end">
              <button
                onClick={() => setOpenModalPendiente(false)}
                className="text-sm text-gray-600 hover:text-gray-800 hover:underline"
              >
                Cerrar
              </button>
            </div>

            {/* Botón cerrar (X) */}
            <button
              onClick={() => setOpenModalPendiente(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              aria-label="Cerrar"
            >
              ✕
            </button>
          </div>
        </div>
      )}



      {/* Modal para Registro Civil */}
      <Dialog
        open={openRegistroCivil}
        onClose={() => { setOpenRegistroCivil(false); setRegistroCivilCaido(false); }}
        maxWidth="md"
        fullWidth
      >
        <RegistroCivil
          cedula={cedula}
          dactilar={dactilar}
          imagenSubida={selectedRow?.imagen}
          estadoSolicitud={selectedRow?.Estado}
          idSolicitud={selectedRow?.id}
          registroCivilCaido={registroCivilCaido}
          puedeAprobarSinRC={aporbarsinregistrocivil()}
          onAceptar={() => {
            verificacionManual(selectedRow?.id, true);
            setOpenRegistroCivil(false);
            setRegistroCivilCaido(false);
          }}
          onRechazar={() => {
            verificacionManual(selectedRow?.id, false);
            setOpenRegistroCivil(false);
            setRegistroCivilCaido(false);
          }}
          resultadoVerificacion={resultadoVerificacion}
          permisos={permisos}
        />
      </Dialog>

      <Dialog
        open={openAuditoriaIntegral}
        onClose={() => setOpenAuditoriaIntegral(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ p: 2, bgcolor: "#eef2f7" }}>
          <AuditoriaIntegral
            initialCedula={auditoriaRow?.cedula}
            initialNombre={auditoriaRow?.nombre}
            data={auditoriaRow}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog de confirmación */}
      <ConfirmarAccionModal
        open={openDialog2}
        onClose={() => setOpenDialog2(false)}
        onConfirm={handleConfirm}
        currentAction={currentAction}
        isReproceso={currentData?.estado === "RE-PROCESO"}
        entrada={entrada}
        setEntrada={setEntrada}
        justificacion={justificacion}
        setJustificacion={setJustificacion}
        domicilioChecked={domicilioChecked}
        setDomicilioChecked={setDomicilioChecked}
        laboralChecked={laboralChecked}
        setLaboralChecked={setLaboralChecked}
      />
      <DocumentoDescarga isOpen={isOpenPDf} onClose={() => setIsOpenPdf(false)} data={dataInforme} />
      <MotivoContinuidad isOpen={isOpenMotivo} onClose={() => setIsOpenMotivo(false)} data={dataInforme} userData={userData} />

      {/* Modal codigo dactilar */}
      <Dialog open={openModalCodDag} onClose={() => setOpenModalCodDag(false)}>
        <DialogTitle>Cambiar codigo Dactilar</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Ingresa el nuevo código dactilar:
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={codDact}
            onChange={(e) => setCodDact(e.target.value)}
            placeholder="Ingresa el código dactilar"
            autoFocus
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalCodDag(false)} color="primary">
            Cerrar
          </Button>
          <Button onClick={handleUpdateClick} color="primary" variant="contained">
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de confirmación */}
      <Dialog
        open={openConfirmModalCodDac}
        onClose={() => setOpenConfirmModalCodDac(false)}
        maxWidth="xs"
      >
        <DialogTitle>Confirmar actualización</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Está seguro de actualizar el código dactilar?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmModalCodDac(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmUpdate} color="primary" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openModalEmail} onClose={() => setOpenModalEmail(false)}>
        <DialogTitle>Cambiar correo electrónico</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Ingresa el nuevo correo de la solicitud:
          </Typography>
          <TextField
            fullWidth
            type="email"
            variant="outlined"
            value={emailSolicitud}
            onChange={(e) => setEmailSolicitud(e.target.value)}
            placeholder="cliente@correo.com"
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalEmail(false)} color="primary">Cerrar</Button>
          <Button onClick={handleUpdateEmailClick} color="primary" variant="contained">Actualizar</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmModalEmail}
        onClose={() => setOpenConfirmModalEmail(false)}
        maxWidth="xs"
      >
        <DialogTitle>Confirmar actualización</DialogTitle>
        <DialogContent>
          <Typography>¿Está seguro de actualizar el correo electrónico?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmModalEmail(false)} color="primary">Cancelar</Button>
          <Button onClick={handleConfirmUpdateEmail} color="primary" variant="contained">Confirmar</Button>
        </DialogActions>
      </Dialog>

      <ExcelModal
        open={openModalExcel}
        onClose={() => setOpenModalExcel(false)}
        bodegas={dataBodega}
      />

      {/* Modal de Error Visual para Registro Civil y Verificación */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
          }
        }}
      >
        <DialogTitle sx={{
          bgcolor: errorModalData.tipo === 'verificacion_exitosa'
            ? '#d4edda'
            : errorModalData.tipo === 'verificacion_fallida'
              ? '#fff3cd'
              : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                ? '#fff3cd'
                : errorModalData.tipo === 'datos_incompletos'
                  ? '#f8d7da'
                  : '#d1ecf1',
          color: errorModalData.tipo === 'verificacion_exitosa'
            ? '#155724'
            : errorModalData.tipo === 'verificacion_fallida'
              ? '#856404'
              : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                ? '#856404'
                : errorModalData.tipo === 'datos_incompletos'
                  ? '#721c24'
                  : '#0c5460',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          pb: 2
        }}>
          {errorModalData.tipo === 'verificacion_exitosa' ? (
            <CheckCircleIcon sx={{ fontSize: 40, color: '#28a745' }} />
          ) : errorModalData.tipo === 'verificacion_fallida' ? (
            <ReportProblemIcon sx={{ fontSize: 40, color: '#ffc107' }} />
          ) : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado' ? (
            <PersonSearchIcon sx={{ fontSize: 40 }} />
          ) : errorModalData.tipo === 'datos_incompletos' ? (
            <ReportProblemIcon sx={{ fontSize: 40 }} />
          ) : (
            <HighlightOffIcon sx={{ fontSize: 40 }} />
          )}
          <Typography variant="h6" component="div" fontWeight="bold">
            {errorModalData.mensaje}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ mt: 3, mb: 2 }}>
          <Box sx={{
            bgcolor: errorModalData.tipo === 'verificacion_exitosa' ? '#f0f9f4' : '#f8f9fa',
            p: 3,
            borderRadius: '8px',
            border: `1px solid ${errorModalData.tipo === 'verificacion_exitosa' ? '#c3e6cb' : '#dee2e6'}`
          }}>
            <Typography
              variant="body1"
              sx={{
                whiteSpace: 'pre-line',
                color: '#495057',
                lineHeight: 1.8
              }}
            >
              {errorModalData.detalle}
            </Typography>
          </Box>

          {(errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado') && (
            <Box sx={{ mt: 3, p: 2, bgcolor: '#e7f3ff', borderRadius: '8px', border: '1px solid #b3d9ff' }}>
              <Typography variant="body2" sx={{ color: '#004085', fontWeight: 500, mb: 1 }}>
                💡 Sugerencias:
              </Typography>
              <Typography variant="body2" sx={{ color: '#004085', pl: 2 }}>
                • Verifique que la cédula esté correctamente digitada<br />
                • Confirme que el código dactilar sea el correcto<br />
                • Consulte con el cliente si es necesario<br />
                • Si el problema persiste, contacte al área técnica
              </Typography>
            </Box>
          )}

          {errorModalData.tipo === 'verificacion_fallida' && (
            <Box sx={{ mt: 3, p: 2, bgcolor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
              <Typography variant="body2" sx={{ color: '#856404', fontWeight: 500, mb: 1 }}>
                ⚠️ Acciones requeridas:
              </Typography>
              <Typography variant="body2" sx={{ color: '#856404', pl: 2 }}>
                • Revise manualmente ambas fotografías<br />
                • Contacte al analista asignado a esta solicitud<br />
                • Considere solicitar nuevas fotos al cliente<br />
                • Documente el motivo del rechazo en el sistema
              </Typography>
            </Box>
          )}

          {errorModalData.tipo === 'verificacion_exitosa' && (
            <Box sx={{ mt: 3, p: 2, bgcolor: '#d4edda', borderRadius: '8px', border: '1px solid #c3e6cb' }}>
              <Typography variant="body2" sx={{ color: '#155724', fontWeight: 500, mb: 1 }}>
                ✓ Verificación completada
              </Typography>
              <Typography variant="body2" sx={{ color: '#155724', pl: 2 }}>
                La solicitud ha sido procesada y aprobada automáticamente.<br />
                Puede continuar con el siguiente paso del proceso.
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => setErrorModalOpen(false)}
            variant="contained"
            sx={{
              bgcolor: errorModalData.tipo === 'verificacion_exitosa'
                ? '#28a745'
                : errorModalData.tipo === 'verificacion_fallida'
                  ? '#ffc107'
                  : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                    ? '#ffc107'
                    : errorModalData.tipo === 'datos_incompletos'
                      ? '#dc3545'
                      : '#17a2b8',
              '&:hover': {
                bgcolor: errorModalData.tipo === 'verificacion_exitosa'
                  ? '#218838'
                  : errorModalData.tipo === 'verificacion_fallida'
                    ? '#e0a800'
                    : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                      ? '#e0a800'
                      : errorModalData.tipo === 'datos_incompletos'
                        ? '#c82333'
                        : '#138496',
              },
              px: 4,
              py: 1,
              borderRadius: '8px',
              fontWeight: 'bold'
            }}
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Verificación Facial con Tailwind CSS */}
      <VerificacionFacialModal
        open={verificacionModalOpen}
        onClose={() => setVerificacionModalOpen(false)}
        tipo={verificacionModalTipo}
        data={verificacionModalData}
      />

      {/* Modal de Firma Electrónica: debe estar fuera de la tabla para sobreponerse */}
      {Number(selectedRow?.TipoFirmaElectronica) === 2 ? (
        <ModalFirmaElectronicaBancoSolidario
          data={selectedRow}
          isOpen={modalFirmaOpen}
          onClose={() => setModalFirmaOpen(false)}
          isPrefacturaAprobada={isPrefacturaAprobadaBS}
          puedeReenviar={Boolean(puedeReenviarFirmaBS())}
        />
      ) : (
        <ModalFirmaElectronica
          data={selectedRow}
          isOpen={modalFirmaOpen}
          onClose={() => setModalFirmaOpen(false)}
          isExistPrefactura={ExistPrefactura}
        />
      )}

    </div>
  );
}
